import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex'
    },
    label: {
        flexGrow: 1,
        margin: 'auto'
    },
    permissions: {
        display: 'flex'
    },
    permission: {
        minWidth: '6rem',
        textAlign: 'center'
    }
}));

const PermissionEditItem = ({
                                availablePermissions,
                                unit,
                                explicitPermissions,
                                inheritedPermissions,
                                userPermissions,
                                onChange
                            }: any) => {
    const classes = useStyles();

    const handleChange = (p: any, e: any) => {
        const checked = e.target.checked;
        const newPermission = checked ? p : permission & (!p as any);
        onChange(unit, newPermission);
    };

    const permission = explicitPermissions | inheritedPermissions;

    return (
        <div className={classes.root}>
            <div className={classes.label}>{unit.name}</div>
            <div className={classes.permissions} onClick={e => e.stopPropagation()}>
                {
                    availablePermissions
                        .map((ap: any) => {
                            return <div key={ap.toString()}
                                        className={classes.permission}>
                                <Checkbox disabled={(inheritedPermissions & ap) === ap
                                || userPermissions < permission
                                || userPermissions < ap}
                                          checked={(permission & ap) === ap}
                                          onChange={e => handleChange(ap, e)}
                                          value="primary"
                                          inputProps={{'aria-label': 'primary checkbox'}}
                                          color="primary"
                                />
                            </div>
                        })
                }
            </div>
        </div>
    );
};

export default PermissionEditItem;
